module.exports = __webpack_public_path__ + "static/media/huli_401.fe963329.gif";